<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>银行账号列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
      <el-row :gutter="24">
        <el-col :span="24">

            <el-form-item label="标题">
              <el-input v-model="searchForm.title" clearable type="text"></el-input>
            </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="searchSubmit()">
                  <i class="el-icon-search" ></i>搜索
              </el-button>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>

          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
        size="mini"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="银行名称"
          width="120"
          :show-overflow-tooltip='true'
        >
            <template slot-scope="scope">
                {{scope.row.bank?scope.row.bank.name:''}}
            </template>
        </el-table-column>
          <el-table-column
                  label="账号"
                  width="200"
                  :show-overflow-tooltip='true'
          >
              <template slot-scope="scope">
                  {{scope.row.bank_account}}
              </template>
          </el-table-column>
        <el-table-column
          label="商户名"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.shop?scope.row.shop.name:''}}
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
        >
          <template slot-scope="scope">
            {{scope.row.status==1?'启用':'禁用'}}
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->

    <el-drawer
            title="轮毂列表"
            :visible.sync="drawerHub"
            :with-header="false">
      <el-table
              style="margin-top: 20px;"
              ref="multipleTable"
              :data="hubList"
              size="mini"
              stripe
              border
      >
<!--        <el-table-column label="" width="50" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-radio v-model="curHub" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column  type="index" label="序号" width="50"></el-table-column>
        <el-table-column
                label="图片"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-image
                    style="width: 50px; height: 50px"
                    :src="scope.row.goods_img"

                    :preview-src-list="[scope.row.goods_img]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
                label="名称"
                width="150"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.goods_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="孔距"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.pitch?scope.row.pitch.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="市场价"
                width="80"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.market_price}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:10px">
        <el-pagination
                background
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="pageNum1"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total1">
        </el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换

  export default {
    name: "shopBankList",
    components: {

    },
    props: {},
    data() {
      return {
          carStyleMenus:[],
        pitch_id:'',
        drawerHub:false,
        hubList:[],
        total1:0,
        pageNum1:1,
        pageSize1:20,

        formData:{},
        title:'',
        visible:false,
        // 搜索
        searchForm: {
            title: "",
          style_ids:[],
          style_id:'',
            year_id:''
        },
          carYearList:[],
        searchRules: {

          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        form: {
          name: '',
        },

      };
    },
    created() {
      this.DataList()
      this.getCarStyleMenus();
      this.getCarYeaList();
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },


    },
    methods: {
        getCarStyleMenus(){
            let _this = this;
            let params={
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
            };
            this.$axios.findCarStyleTree(params).then((res)=>{
                if(res.code == 200) {
                    _this.carStyleMenus=res.data;
                }
            });
        },
        getCarYeaList(){
            let _this = this;
            let params={
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
            };
            this.$axios. findCarYearList(params).then((res)=>{
                if(res.code == 200) {
                    _this.carYearList=res.data;
                }
            });
        },
        getval() {
            let _this = this;
            const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
            console.log('obj',obj)
            if(obj.length>0){
                _this.searchForm.style_id = obj[0].data.id;
            }else{
                _this.searchForm.style_id="";
            }

        },
      relationHub(row){
        this.drawerHub=true;
        this.pitch_id=row.pitch_id;
        this.getHubList();
      },
      getHubList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum1:this.pageNum1,
          pageSize1: this.pageSize1,
          pitch_id:this.pitch_id
        }
        this.$axios.findHubListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.hubList = res.data.data
            this.total1 = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      closeForm(){
        this.title="";
        this.visible=false;
      },
      goEdit(row){
        this.$router.push({path:'/carForm',query:{id:row.id}})
        // this.title="编辑用户";
        // this.formData.realname=row.realname;
        // this.formData.nickname=row.nickname;
        // this.formData.user_id=row.user_id;
        // this.formData.user_name=row.user_name;
        // this.formData.parent_id=row.parent_id;
        // this.formData.parent_name=row.parent?row.parent.realname:'';
        // this.visible=true;
      },
      goAdd(){
        // this.$router.replace('/carForm')
        this.$router.push('/carForm')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          shop_id:sessionStorage.getItem('shop_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(this.searchForm.title){
          param.keyword=this.searchForm.title;
        }
        console.log(this.searchForm.style_ids)
          if(this.searchForm.style_id){
              param.style_id=this.searchForm.style_id;
          }
          if(this.searchForm.year_id){
              param.year_id=this.searchForm.year_id;
          }
        this.$axios.findShopBankListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      handleSizeChange1(newSize) {
        this.pageSize1 = newSize
        this.getHubList()
      },
      // 分页跳转
      handleCurrentChange1(newPage) {
        this.pageNum1 = newPage
        this.getHubList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/newsForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
       this.total=0;
       this.pageNum=1;
       this.tableLoadData=[];

       this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
